import styled from "styled-components";
import { pxToRem } from "../utils";

export const H1 = styled.span`
  display: block;
  font-size: ${pxToRem(26)};
  font-weight: 600;
`;
